import { Component, OnInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-page-terms-and-conditions',
    templateUrl: './page-terms-and-conditions.component.html',
    styleUrls: ['./page-terms-and-conditions.component.scss'],
    standalone: false
})
export class PageTermsAndConditionsComponent implements OnInit {

  constructor(public translate: TranslateService) { }

  ngOnInit(): void {
  }

}
